import type { SearchHit } from "./searchApi";

/**
 * Maps a global-search hit to the route of its underlying entity.
 * Extracted from the former standalone PesquisaView so the header
 * search dropdown navigates consistently.
 */
export function getSearchHitPath(hit: SearchHit): string {
  switch (hit.type) {
    case "Cliente":
      return `/clientes/editar/${hit.id}`;
    case "Fornecedor":
      return `/fornecedores/editar/${hit.id}`;
    case "Subempreiteiro":
      return `/subempreiteiros/editar/${hit.id}`;
    case "Obra":
      return `/obras/${hit.id}`;
    case "Fatura":
      return `/obras/${hit.id}`;
    default:
      return "/dashboard";
  }
}
